export const calculateAge = (yearOfBirth) => {
  let today = new Date();
  let year = today.getFullYear();
  let age = year - yearOfBirth;
  return age;
};
